import { useMutation } from '@tanstack/react-query';
import { environment } from '../config/environment';
import type { Form } from '../interfaces/form.interface';

interface ConfirmWalletData {
  metadata: Record<string, string | boolean | number | string[]>;
  configuration: Form;
}

export const useConfirmWallet = (walletId: string) => {
  return useMutation({
    mutationFn: async (data: ConfirmWalletData) => {
      const response = await fetch(`${environment.API}/wallets/${walletId}/confirmations`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Failed to confirm wallet');
      }

      return response.json();
    },
  });
};
